module.exports = __webpack_public_path__ + "img/stylize.6c64a2a3.svg";